import React, { Component } from 'react'

import { Helmet } from "react-helmet";
import {  Route, Link, Switch } from 'react-router-dom'
import { Collapse } from 'react-collapse';
import { presets } from 'react-motion';
import PropTypes from 'prop-types';
import { extend } from 'lodash'
import capitalize from 'capitalize'
import { SearchkitManager,SearchkitProvider,
  SearchBox, RefinementListFilter, Pagination, HitsStats, SortingSelector, NoHits,
  ResetFilters, Hits, GroupedSelectedFilters,
  Layout, TopBar, LayoutBody, LayoutResults,
  ActionBar, ActionBarRow, SideBar } from 'searchkit'

const host = "http://e.cogapp.com/cogapp-images"
const searchkit = new SearchkitManager(host, {
  // basicAuth:"elastic:changeme"
})
const baseUrl = process.env.PUBLIC_URL;

const ArtworkGridItem = (props)=> {
  const {bemBlocks, result} = props
  const source:any = extend({}, result._source, result.highlight)
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <Link to={`${baseUrl}/artwork/${result._source.image_id}`}>
        <img data-qa="poster" alt="presentation" className={bemBlocks.item("poster")} src={source.thumbnail_url} />
        <div data-qa="title" className={bemBlocks.item("title")} dangerouslySetInnerHTML={{__html: source.caption_text}}></div>
      </Link>
    </div>
  )
}

class Artwork extends Component {
  constructor (props) {
    super(props);
    this.state = {
      item_id: props.match.params.item,
      artwork: null,
      loaded: false,
      caption_text: null,
      tags: null,
      link: null,
      title: null,
      copyright: null,
      iiif: null
    };
  }
  
  fetchData(){
    const baseUri = `http://e.cogapp.com`
    const url = `${baseUri}/cogapp-images/_search?q=image_id:${this.state.item_id}`
    fetch(url)
      .then((response) => {
        if(response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      }).then((data) => {
        this.setState({
          artwork: data.hits.hits
        });
      }).then(() => {
        this.getCaption(this.state.artwork)
        this.getTags(this.state.artwork)
        this.setState({
          link: this.state.artwork[0]._source.nm_link,
          title: this.state.artwork[0]._source.nm_title,
          copyright: this.state.artwork[0]._source.copyright,
          iiif: this.state.artwork[0]._source.large_url
        });
      }).catch((error) => {
        console.log(error)

      });
  }
  
  getCaption(results){
    var captions = results.map((el) =>  this.ucase(el._source.caption_text));
    captions = captions.filter((i) => i);
    this.setState({
      caption_text: captions
    })
  }

  getTags(results){
    var tags = results.map((el) => {return {[el._source.source]: el._source.tags};});
    tags = tags.filter((i) => i);
    this.setState({
      tags: tags,
      loaded: true
    })
  }

  componentDidMount(){
    this.fetchData();
  }

  ucase(string){
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }

  render() {
    const loaded = this.state.loaded ? true : false;
    let image, labels = null;
    
    if (loaded) {
      image = <StandaloneImage 
        id={this.state.item_id}
        caption_text={this.state.caption_text} 
        title={this.state.title}
        link={this.state.link}
        iiif={this.state.iiif}
        copyright={this.state.copyright}
      />;
    } else {
      image = <p>Loading...</p>;
    }

    if (loaded) {
      labels = <StandaloneTags tags={this.state.tags} />
    } else {
      labels = null;
    }

    return (
      <div className="sk-layout">
        <Helmet>
          <title>{`${this.state.caption_text} | A Cogapp Labs experiment`}</title>
          <meta id="og-title" property="og:title" content={this.state.caption_text} />
          <meta id="og-description" property="og:description" content="Machine learning, it sees what it wants to see." />
          <meta id="og-image" property="og:image" content={`http://nationalmuseumse.iiifhosting.com/iiif/${this.state.item_id}/full/!1200,630/0/default.jpg`} />
          <meta id="twitter-card" name="twitter:card" content="summary_large_image" />
          <meta id="twitter-title" name="twitter:title" content={this.state.caption_text} />
          <meta id="twitter-description" name="twitter:description" content="Machine learning, it sees what it wants to see." />
          <meta id="twitter-image" name="twitter:image" content={`http://nationalmuseumse.iiifhosting.com/iiif/${this.state.item_id}/full/!1200,630/0/default.jpg`} />
        </Helmet>
        <div className="sk-layout__standalone">
          <div className="standalone-frame">
            {image}
            {labels}
            <div className="standalone-metadata">
              <p>Artwork title: {this.state.title}</p>
              <p><a href={this.state.link} target="_blank">View artwork at nationalmuseum.se</a></p>
              <p><a href={this.state.iiif} target="_blank">IIIF image source</a></p>
              <p><a href={this.state.copyright}>{this.state.copyright}</a></p>
            </div>
            <div className="sk-layout__other">
              <Link  to={`${baseUrl}`}>{"See all the artworks"}</Link>
              <AboutText />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const StandaloneImage = (props) => {
  return (
    <div>
      <img className="" src={`http://nationalmuseumse.iiifhosting.com/iiif/${props.id}/full/!600,600/0/default.jpg`} alt={props.caption_text[0]} />
      <StandaloneImageCaption caption={props.caption_text[0]} />
    </div>
  )
}

const StandaloneImageCaption = (props) => {
  return (
    <div className="standalone-caption">
      <div className="title">
        {capitalize(props.caption)}
        <span className="caption-disclaimer">Caption attempted by Microsft Computer Vision</span>
      </div>
  </div>
  )
}

const Tagset = ({tags, provider}) => {
  const Tags = tags.map((tag, i) => <li key={i}><a href={`${baseUrl}/?tags[0]=${tag}`}>{tag}</a></li>);
  return (
    <div className="standalone-tags">
      <span className="tagset-provider">{capitalize(provider)}</span>
      <ul className="tagset">{Tags}</ul>
    </div>
  )
}

const StandaloneTags = ({tags}) => {
  return (            
    <div className="standalone-labels">
      <h4>Label detection</h4>
      <div className="">
        {tags.map(function(tagSet, key){ 
          return (
            Object.keys(tagSet).map(function(provider){
              return (  
                <Tagset tags={tagSet[provider]} provider={provider} />
              )
            })
          );
        })}
      </div>
    </div>
  )
}

const ArtworkTags = (props) => {
  const Tags = props.tags.map((tag, i) => <span key={i}>{!!i && ", "}{tag}</span>);
  return (
    <div className="inline-tags">Tags:{Tags}</div>
  )
}

class Search extends Component {
  render() {
    return (
      <SearchkitProvider searchkit={searchkit}>
        <Layout size="l">
          <TopBar>
            <SearchBox autofocus={true} searchOnChange={true} prefixQueryFields={['tags']}/>
          </TopBar>
        <LayoutBody>

          <SideBar>
            <RefinementListFilter id="provider" title="Provider" field="source.keyword" operator="OR" size={10}/>
            <RefinementListFilter id="tags" title="Labels" field="tags.keyword" size={40}/>
          </SideBar>
          <LayoutResults>
            <AboutText />
            <ActionBar>
              <ActionBarRow>
                <HitsStats translations={{
                  "hitstats.results_found":"{hitCount} results found"
                }}/>
                <SortingSelector options={[
                  {label:"Relevance", field:"_score", order:"desc"},
                  {label:"Caption confidence", field:"caption_confidence", order:"desc"}
                ]}/>
              </ActionBarRow>

              <ActionBarRow>
                <GroupedSelectedFilters/>
                <ResetFilters/>
              </ActionBarRow>
              
            </ActionBar>
            <Hits hitsPerPage={20} mod="sk-hits-grid" itemComponent={ArtworkGridItem} />
            <NoHits suggestionsField={"tags"}/>
            <Pagination showNumbers={true}/>
          </LayoutResults>

          </LayoutBody>
        </Layout>
      </SearchkitProvider>  
    );
  }
}

const modal_html = '<h2>About this project</h2><p>This search interface was created by Neil Hawkins of Cogapp, for the IIIF conference at the Vatican Library in June 2017</p><p>It demonstrates the effectiveness of three computer vision APIs: <a href="https://clarifai.com">Clarifai</a>, <a href="https://azure.microsoft.com/en-gb/services/cognitive-services/computer-vision/">Computer Vision</a>, from Microsoft and <a href="https://cloud.google.com/vision/">Vision API</a>, by Google.</p><p>For each service, we analysed approximately 2000 images taken from the collection of the <a href="http://www.nationalmuseum.se">Nationalmuseum</a>, Sweden. Most images are under a Public Domain license, but please consult the museum&#39;s website to check exact terms of use.</p>    <p>Check out our <a href="https://blog.cogapp.com/automated-image-analysis-with-iiif-6594ff5b2b32">blog post</a> and <a href="https://drive.google.com/file/d/0B2-uB9tnE8NpbzdfSlU2QTFTbWM/view">slide deck</a> for more information.</p><br>';


class AboutText extends React.Component {
  static propTypes = {
    isOpened: PropTypes.bool
  };


  static defaultProps = {
    isOpened: false
  };


  constructor(props) {
    super(props);
    this.state = {isOpened: this.props.isOpened};
  }

  render() {
    const {isOpened} = this.state;

    return (
      <div className="modal-wrapper">
        <div>
          <span className="button modal-button" onClick={() => this.setState({isOpened: !isOpened})}>{!isOpened ? "About this project" : "Close"}</span>
        </div>

        <Collapse isOpened={isOpened}>
          <div className="modal-content" dangerouslySetInnerHTML={{__html: modal_html}}>
          </div>
        </Collapse>
      </div>
    );
  }
}

const App = () => (
  <main>
    <Switch>
      <Route exact path={baseUrl + '/'} component={Search}/>
      <Route path={baseUrl + '/artwork/:item'} component={Artwork} />
    </Switch>
  </main>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js